import React from 'react';
import { getSiteParams } from '../../shared/siteParams';

// Cookie-consent баннер. Аналог
// `website_default/js/react/shared/cookie_consent/cookie_consent.component.jsx`.
//
// Виден один раз — при клике «Согласен» сохраняем флаг в localStorage,
// больше не показываем. Содержимое (текст, кнопка, ссылки) — из
// site_params.cookie_widget_*.

const STORAGE_KEY = 'cookieConsentDismissedAt';

export class CookieConsentBanner extends React.Component {
  constructor(props) {
    super(props);
    let dismissed = false;
    try { dismissed = localStorage.getItem(STORAGE_KEY) != null; } catch (e) { /* noop */ }
    this.state = { dismissed };
    this.dismiss = this.dismiss.bind(this);
  }

  dismiss() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) { /* noop */ }
    this.setState({ dismissed: true });
  }

  render() {
    if (this.state.dismissed) return null;
    const sp = getSiteParams();
    if (!sp.cookie_widget_enabled) return null;
    const text = sp.cookie_widget_text || '';
    const btnText = sp.cookie_widget_button_text || 'Согласен';
    const links = sp.cookie_widget_links || [];
    return (
      <div className="cookie-consent">
        <div className="cookie-consent__text">{text}</div>
        {links.length > 0 && (
          <div className="cookie-consent__links">
            {links.map((l, i) => (
              <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className="cookie-consent__link">
                {l.title}
              </a>
            ))}
          </div>
        )}
        <button type="button" className="btn cookie-consent__btn" onClick={this.dismiss}>{btnText}</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cookie/CookieConsentBanner.jsx